// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MxV7","left":"styles_left__1YIUu"};